const configuredDocumentSaveTimeout = Number(process.env.REACT_APP_DOCUMENT_SAVE_TIMEOUT_MS);
const configuredDocumentLoadTimeout = Number(process.env.REACT_APP_DOCUMENT_LOAD_TIMEOUT_MS);

const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  baseUrl: process.env.REACT_APP_BASE_URL,
  env: process.env.REACT_APP_ENV,
  isProduction: process.env.NODE_ENV === 'production',
  isDevelopment: process.env.NODE_ENV === 'development',
  documentSaveTimeoutMs: Number.isInteger(configuredDocumentSaveTimeout)
    && configuredDocumentSaveTimeout > 0
    ? configuredDocumentSaveTimeout
    : 45000,
  documentLoadTimeoutMs: Number.isInteger(configuredDocumentLoadTimeout)
    && configuredDocumentLoadTimeout > 0
    ? configuredDocumentLoadTimeout
    : 30000,
};

console.log(`🔧 Załadowano konfigurację dla środowiska: ${config.env}`);

export default config;
